(function () {
  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function readConfig(section) {
    return {
      paramName: section.dataset.orderParam || 'order',
      useShopifyLookup: section.dataset.useShopifyLookup !== 'false',
      isCustomer: section.dataset.isCustomer === 'true',
      guestMessage:
        section.dataset.guestMessage ||
        'Log in with the email used at checkout to view order status for this order number.',
      notFoundMessage:
        section.dataset.notFoundMessage ||
        'No order found with that number. Check the number in your confirmation email and try again.',
      loginUrl: section.dataset.loginUrl || '/account/login',
      sectionId: section.dataset.sectionId,
      customerAccountApi: section.dataset.customerAccountApi || '',
      orderGid: section.dataset.orderGid || ''
    };
  }

  var shipmentStatusLabels = {
    IN_TRANSIT: 'In transit',
    OUT_FOR_DELIVERY: 'Out for delivery',
    DELIVERED: 'Delivered',
    CONFIRMED: 'Confirmed',
    ATTEMPTED_DELIVERY: 'Attempted delivery',
    READY_FOR_PICKUP: 'Ready for pickup',
    PICKED_UP: 'Picked up',
    LABEL_PRINTED: 'Label printed',
    LABEL_PURCHASED: 'Label purchased',
    DELAYED: 'Delayed',
    FAILURE: 'Delivery issue',
    CARRIER_PICKED_UP: 'Picked up by carrier'
  };

  function formatShipmentStatus(status) {
    if (!status) return '';
    if (shipmentStatusLabels[status]) return shipmentStatusLabels[status];
    return String(status).replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, function (char) {
      return char.toUpperCase();
    });
  }

  function shipmentStatusClass(status) {
    if (!status) return 'default';
    return String(status).toLowerCase().replace(/_/g, '-');
  }

  function applyDeliveryStatus(section, status) {
    var target = section.querySelector('[data-track-order-delivery-status]');
    if (!target || !status) return;

    var label = formatShipmentStatus(status);
    var badgeClass = shipmentStatusClass(status);

    target.innerHTML =
      '<span class="custom-track-order__delivery-badge custom-track-order__delivery-badge--' +
      escapeHtml(badgeClass) +
      '">' +
      escapeHtml(label) +
      '</span>';

    var row = section.querySelector('[data-track-order-delivery-row]');
    if (row) row.hidden = false;
  }

  function extractLatestShipmentStatus(payload) {
    if (!payload || !payload.data) return '';

    if (payload.data.order && payload.data.order.fulfillments && payload.data.order.fulfillments.nodes) {
      var orderNodes = payload.data.order.fulfillments.nodes;
      for (var i = 0; i < orderNodes.length; i++) {
        if (orderNodes[i].latestShipmentStatus) return orderNodes[i].latestShipmentStatus;
      }
    }

    if (
      payload.data.customer &&
      payload.data.customer.orders &&
      payload.data.customer.orders.nodes &&
      payload.data.customer.orders.nodes[0]
    ) {
      var fulfillments = payload.data.customer.orders.nodes[0].fulfillments;
      if (fulfillments && fulfillments.nodes) {
        for (var j = 0; j < fulfillments.nodes.length; j++) {
          if (fulfillments.nodes[j].latestShipmentStatus) {
            return fulfillments.nodes[j].latestShipmentStatus;
          }
        }
      }
    }

    return '';
  }

  function fetchDeliveryStatus(section, config, orderValue) {
    if (!config.isCustomer || !config.customerAccountApi) return Promise.resolve();

    var deliveryTarget = section.querySelector('[data-track-order-delivery-status]');
    if (!deliveryTarget) return Promise.resolve();

    var orderGid =
      config.orderGid ||
      (section.querySelector('[data-order-gid]') && section.querySelector('[data-order-gid]').dataset.orderGid);

    var query;
    var variables;

    if (orderGid) {
      query =
        'query OrderDelivery($id: ID!) { order(id: $id) { fulfillments(first: 5) { nodes { latestShipmentStatus } } } }';
      variables = { id: orderGid };
    } else if (orderValue) {
      var normalized = String(orderValue).trim().replace(/^DGX/i, '');
      var orderName = normalized.indexOf('#') === 0 ? normalized : '#' + normalized;

      query =
        'query OrdersByName($query: String!) { customer { orders(first: 1, query: $query) { nodes { fulfillments(first: 5) { nodes { latestShipmentStatus } } } } } }';
      variables = { query: 'name:' + orderName };
    } else {
      return Promise.resolve();
    }

    return fetch(config.customerAccountApi, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: query, variables: variables })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (payload) {
        var status = extractLatestShipmentStatus(payload);
        if (status) applyDeliveryStatus(section, status);
      })
      .catch(function () {
        /* Keep Liquid fallback label */
      });
  }

  function refreshDeliveryStatus(section, config) {
    if (!config.isCustomer || !section.querySelector('[data-track-order-delivery-status]')) return;

    var params = new URLSearchParams(window.location.search);
    var orderValue =
      params.get(config.paramName) ||
      (section.querySelector('.custom-track-order__input') &&
        section.querySelector('.custom-track-order__input').value.trim());

    fetchDeliveryStatus(section, config, orderValue);
  }

  function buildLoginUrl(baseLoginUrl, returnPath) {
    var loginBase = (baseLoginUrl || '').split('?return_url=')[0].split('&return_url=')[0];
    var separator = loginBase.indexOf('?') >= 0 ? '&' : '?';
    return loginBase + separator + 'return_url=' + encodeURIComponent(returnPath);
  }

  function visibleResult(section) {
    return section.querySelector('.custom-track-order__result:not([hidden])');
  }

  function renderGuestResult(section, config, orderValue) {
    if (visibleResult(section)) return;

    var guestResult = section.querySelector('.custom-track-order__result--guest-pending');
    if (guestResult) {
      var loginLink = guestResult.querySelector('[data-track-order-login]');
      if (loginLink && orderValue) {
        var returnPath =
          window.location.pathname + '?' + config.paramName + '=' + encodeURIComponent(orderValue);
        loginLink.href = buildLoginUrl(config.loginUrl || loginLink.getAttribute('href'), returnPath);
      }

      guestResult.hidden = false;
      section.classList.add('custom-track-order--has-result');
      return;
    }

    var form = section.querySelector('.custom-track-order__form');
    if (!form) return;

    var result = document.createElement('div');
    result.className = 'custom-track-order__result';
    result.setAttribute('role', 'status');
    result.setAttribute('aria-live', 'polite');

    var returnPath = orderValue
      ? window.location.pathname + '?' + config.paramName + '=' + encodeURIComponent(orderValue)
      : window.location.pathname;

    result.innerHTML =
      '<div class="custom-track-order__result-card custom-track-order__result-card--login">' +
      '<p class="custom-track-order__result-message">' +
      escapeHtml(config.guestMessage) +
      '</p>' +
      '<a href="' +
      escapeHtml(buildLoginUrl(config.loginUrl, returnPath)) +
      '" class="custom-track-order__result-login">Log in to view order status</a>' +
      '</div>';

    form.insertAdjacentElement('afterend', result);
    section.classList.add('custom-track-order--has-result');
  }

  function renderNotFoundResult(section, config) {
    if (visibleResult(section)) return;

    var form = section.querySelector('.custom-track-order__form');
    if (!form) return;

    var result = document.createElement('div');
    result.className = 'custom-track-order__result';
    result.setAttribute('role', 'status');
    result.setAttribute('aria-live', 'polite');
    result.innerHTML =
      '<div class="custom-track-order__result-card custom-track-order__result-card--error">' +
      '<p class="custom-track-order__result-message">' +
      escapeHtml(config.notFoundMessage) +
      '</p>' +
      '</div>';

    form.insertAdjacentElement('afterend', result);
    section.classList.add('custom-track-order--has-result');
  }

  function fetchSection(config, orderValue) {
    if (!config.sectionId) return Promise.resolve(false);

    var wrapper = document.getElementById('shopify-section-' + config.sectionId);
    if (!wrapper) return Promise.resolve(false);

    var url = new URL(window.location.pathname, window.location.origin);
    url.searchParams.set('sections', config.sectionId);
    url.searchParams.set(config.paramName, orderValue);

    return fetch(url.toString())
      .then(function (response) {
        if (!response.ok) return false;
        return response.json();
      })
      .then(function (data) {
        if (!data || !data[config.sectionId]) return false;

        wrapper.outerHTML = data[config.sectionId];

        var refreshed = document.getElementById('shopify-section-' + config.sectionId);
        var refreshedSection = refreshed && refreshed.querySelector('.custom-track-order');

        if (refreshedSection) {
          refreshedSection.classList.add('custom-track-order--has-result');
          bindSection(refreshedSection);
          refreshDeliveryStatus(refreshedSection, readConfig(refreshedSection));
          return visibleResult(refreshedSection) != null;
        }

        return false;
      })
      .catch(function () {
        return false;
      });
  }

  function handleLookup(section, config, orderValue, updateUrl) {
    if (!orderValue) return;

    var input = section.querySelector('.custom-track-order__input');
    if (input && input.value.trim() !== orderValue) {
      input.value = orderValue;
    }

    if (visibleResult(section)) {
      section.classList.add('custom-track-order--has-result');
      refreshDeliveryStatus(section, config);
      return;
    }

    if (updateUrl) {
      var nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set(config.paramName, orderValue);
      window.history.replaceState({}, '', nextUrl.toString());
    }

    if (!config.useShopifyLookup) return;

    if (config.isCustomer) {
      fetchSection(config, orderValue).then(function (loaded) {
        if (!loaded) renderNotFoundResult(section, config);
      });
      return;
    }

    renderGuestResult(section, config, orderValue);
  }

  function bindSection(section) {
    if (section.dataset.trackOrderBound === 'true') return;
    section.dataset.trackOrderBound = 'true';

    var config = readConfig(section);
    var form = section.querySelector('.custom-track-order__form');
    var params = new URLSearchParams(window.location.search);
    var orderFromUrl = params.get(config.paramName);

    if (orderFromUrl && !visibleResult(section)) {
      handleLookup(section, config, orderFromUrl, false);
    } else if (visibleResult(section)) {
      refreshDeliveryStatus(section, config);
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        if (!config.useShopifyLookup) return;

        var input = section.querySelector('.custom-track-order__input');
        var orderValue = input && input.value.trim();
        if (!orderValue) return;

        event.preventDefault();
        handleLookup(section, config, orderValue, true);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-section-type="custom-track-order"]').forEach(bindSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
